<body>
  <header class="flex justify-center items-center">
    <img src="cb-logo.svg" />
  </header>
  <main class="loan-page login-main">
    <h1>Sign In</h1>
    <div class="login-columns">
    <div class="loan-section max-w-400 w-full">
      @if (loginStep !== 'otp') {
        <app-loan-input label="Email" [control]="usernameControl" />
      }

      @if (loginStep === 'email') {
        <div class="flex justify-between items-center">
          <app-button (click)="continueAfterEmail()">Continue</app-button>
        </div>
      }

      @if (loginStep === 'password') {
        <app-loan-input label="Password" [control]="passwordControl" type="password" [enableVisibilityToggle]="true" />
        <div class="flex justify-between items-center">
          <div class="flex items-center" style="gap: 12px;">
            <app-button (click)="backToEmail()" buttonType="outline">Back</app-button>
            <app-button (click)="login()">Sign In</app-button>
            @if (showResendVerification) {
              <app-button buttonType="outline" (click)="resendVerification($event)">Resend</app-button>
            }
          </div>
          <app-loan-checkbox class="px-20" text="Keep me signed in" groupName="Signin" [control]="keepControl" />
        </div>
      }

      @if (loginStep === 'passkey') {
        <div class="flex flex-col" style="gap: 12px;">
          <app-button (click)="signInWithPasskey()">Sign in with passkey</app-button>
          <app-button buttonType="outline" (click)="backToEmail()">Back</app-button>
          <app-loan-checkbox class="px-20" text="Keep me signed in" groupName="Signin" [control]="keepControl" />
          <p class="text-cb-gold text-700 wgt-600 hover-pointer" (click)="loginStep = 'password'">Use password instead</p>
        </div>
      }

      @if (loginStep === 'otp') {
        <p>We sent a one-time code to {{ otpEmail }}. Enter it below.</p>
        <app-loan-input label="Verification code" [control]="otpControl" />
        <div class="flex justify-between items-center">
          <app-button buttonType="outline" (click)="backFromOtp()">Back</app-button>
          <app-button (click)="otpLoading ? null : submitOtp()">{{ otpLoading ? 'Verifying…' : 'Verify and sign in' }}</app-button>
        </div>
      }

      <div class="flex justify-between items-center">
        <p routerLink="/signup" class="text-cb-gold text-700 wgt-600 hover-pointer">Sign Up</p>
        @if (loginStep === 'password') {
          <p routerLink="/reset-password" class="text-cb-gold text-700 wgt-600 hover-pointer">Forgot Password?</p>
        }
      </div>

      <p class="text-err text-">{{ errMsg }}</p>
      @if (resendMsg) {
        <p>{{ resendMsg }}</p>
      }
    </div>

    <aside class="loan-section max-w-400 w-full online-banking-cta" aria-label="Online banking sign-in">
      <p class="online-banking-cta__title">Commercial loan application via online banking</p>
      <p class="online-banking-cta__body">
        If you use Central Bank online banking, you can open the commercial loan application from there after you sign in.
      </p>
      <a class="online-banking-cta__button" [href]="onlineBankingUrl" target="_blank" rel="noopener noreferrer">
        Log in to online banking
      </a>
    </aside>
    </div>
  </main>
</body>
